import { render, staticRenderFns } from "./article.vue?vue&type=template&id=24b4c70b&scoped=true"
import script from "./article.vue?vue&type=script&lang=js"
export * from "./article.vue?vue&type=script&lang=js"
import style0 from "../../../style/common-pc.scss?vue&type=style&index=0&id=24b4c70b&prod&lang=scss&scoped=true&external"
import style1 from "../../../style/exchange-shop/pc/common.scss?vue&type=style&index=1&id=24b4c70b&prod&lang=scss&scoped=true&external"
import style2 from "./article.vue?vue&type=style&index=2&id=24b4c70b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../content-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b4c70b",
  null
  
)

export default component.exports